export default "<span [ngClass]=\"nameClass\">\n    {{ patient.name }}\n</span>\n"